import React from 'react';

interface CheckboxButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  value: string;
  className?: string;
}

export const CheckboxButton: React.FC<CheckboxButtonProps> = ({
  checked,
  onChange,
  label,
  value,
  className = '',
  ...props
}) => (
  <label
    className={`flex items-center space-x-2 cursor-pointer select-none hover:font-bold ${className}`}
  >
    <span
      className={`w-[1.25rem] h-[1.25rem] flex items-center justify-center ${checked ? 'bg-primary' : 'bg-[#E1E9F0]'} transition-colors`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        value={value}
        className="absolute w-[1.25rem] h-[1.25rem] opacity-0 cursor-pointer"
        {...props}
      />
      {checked && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 10.5L9 14.5L15 7.5"
            stroke="#fff"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
    <span className="font-ambit text-[0.9375rem] not-italic leading-[1.25rem] text-secondary">
      {label}
    </span>
  </label>
);
